import { useTheme } from "@mui/material/styles";

import { themeMode } from "../../providers/theme/MuiThemeProvider";

const GateGuardMenuIconFilled = (): JSX.Element => {
  const theme = useTheme();

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill={theme.palette.primary.main} />
      <path
        d="M17.667 20.5832V10.5832C17.667 10.3531 17.4804 10.1665 17.2503 10.1665H8.08366C7.85354 10.1665 7.66699 10.3531 7.66699 10.5832V20.5832C7.66699 20.8133 7.85354 20.9998 8.08366 20.9998H9.33366M17.667 20.5832C17.667 20.8133 17.4804 20.9998 17.2503 20.9998H12.667M17.667 20.5832V13.0832C17.667 12.8531 17.8535 12.6665 18.0837 12.6665H20.8277C20.9382 12.6665 21.0442 12.7104 21.1224 12.7885L24.2116 15.8778C24.2898 15.9559 24.3337 16.0619 24.3337 16.1724V20.5832C24.3337 20.8133 24.1471 20.9998 23.917 20.9998H22.667M17.667 20.5832C17.667 20.8133 17.8535 20.9998 18.0837 20.9998H19.3337M9.33366 20.9998C9.33366 21.9203 10.0799 22.6665 11.0003 22.6665C11.9208 22.6665 12.667 21.9203 12.667 20.9998M9.33366 20.9998C9.33366 20.0794 10.0799 19.3332 11.0003 19.3332C11.9208 19.3332 12.667 20.0794 12.667 20.9998M19.3337 20.9998C19.3337 21.9203 20.0799 22.6665 21.0003 22.6665C21.9208 22.6665 22.667 21.9203 22.667 20.9998M19.3337 20.9998C19.3337 20.0794 20.0799 19.3332 21.0003 19.3332C21.9208 19.3332 22.667 20.0794 22.667 20.9998"
        stroke={
          theme.palette.mode === themeMode.light
            ? theme.palette.otherBackgroundLight.main
            : theme.palette.text.primary
        }
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default GateGuardMenuIconFilled;
